import React from "react";
import { Box, Collapse } from "@mui/material";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface MyNewsFilterBodyProps {
  open: boolean;
  children: React.ReactNode;
  type: string;
  width?: string | number;
}

export const MyNewsFilterBody: React.FC<MyNewsFilterBodyProps> = ({
  open,
  children,
  type,
  width,
}) => {
  const isMobile = useOcIsMobile();

  if (!children) {
    return null;
  }

  const element = document.getElementById(`my-news-filter-item-${type}`);
  const marginLeft = element ? element.getBoundingClientRect().left - 327 : 0;

  const backgroundColor = type === "contract" ? "#F1F3F4" : "#E3E5E6";

  return (
    <Box
      style={{
        backgroundColor: backgroundColor,
        borderRadius: "4px",
        border: open ? `1px solid #C6CACC` : "none",
        marginLeft: isMobile ? "unset" : `${marginLeft}px`,
        marginTop: "-16px",
        width: width || "340px",
        marginBottom: "16px",
      }}
    >
      <Collapse in={open} timeout={150}>
        {children}
      </Collapse>
    </Box>
  );
};

export default MyNewsFilterBody;
